var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDivitBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.839,
    height: 23.481,
    viewBox: "0 0 65.839 23.481",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Header_with_shopping_cart_Mobile",
    "data-name": "Header with shopping cart \\u2013 Mobile",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M214.115,191.654a1.715,1.715,0,0,1-3.43,0A1.715,1.715,0,0,1,214.115,191.654Zm-3.168,3.263V206.7h2.907V194.917Z",
    transform: "translate(-178.21 -183.476)",
    fill: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M164.853,211.27l-5,11.8h-3.141l-5.022-11.8h3.166l1.618,3.879,1.808,4.949,1.785-4.9,1.62-3.926Z",
    transform: "translate(-132.92 -199.838)",
    fill: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M83.605,190.351V207H80.891l-.19-1.619a4.276,4.276,0,0,1-3.787,1.881,5.76,5.76,0,0,1-6.048-6.143c0-4.049,2.548-6.145,5.976-6.145a4.863,4.863,0,0,1,3.859,1.881v-6.5Zm-9.834,10.765a3.371,3.371,0,1,0,6.74,0,3.351,3.351,0,0,0-3.407-3.43A3.239,3.239,0,0,0,73.771,201.116Z",
    transform: "translate(-70.866 -183.778)",
    fill: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M236.395,197.259v3.259h3.238v2.5h-3.263v5.149a1.459,1.459,0,0,0,1.524,1.668,3.33,3.33,0,0,0,1.406-.357l.811,2.476a6.52,6.52,0,0,1-2.406.5c-2.548.1-4.215-1.357-4.215-4.287v-5.149H231.3v-2.5h2.191v-2.948Z",
    transform: "translate(-194.034 -189.081)",
    fill: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M137.982,191.616a1.715,1.715,0,0,1-3.43,0A1.715,1.715,0,0,1,137.982,191.616Zm-3.168,3.263v11.787h2.906V194.88Z",
    transform: "translate(-119.76 -183.447)",
    fill: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M304.629,218.333l-.29,3.268.29,3.268,2.83-1.634,2.83-1.634-2.54-1.924Z",
    transform: "translate(-250.111 -205.261)",
    fill: "#1c1c1c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M329,204.262l-.29,3.268L329,210.8l2.83-1.634,2.83-1.634-2.54-1.924Z",
    transform: "translate(-268.822 -194.458)",
    fill: "#1c1c1c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M329,182.657l-.29-3.268.29-3.268,2.83,1.634,2.83,1.634-2.54,1.924Z",
    transform: "translate(-268.822 -172.853)",
    fill: "#1c1c1c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M329.96,193.46l2.83-1.634,2.83-1.634v6.536l-2.83-1.634Z",
    transform: "translate(-269.781 -183.655)",
    fill: "#1c1c1c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M304.629,168.586l-.29-3.268.29-3.268,2.83,1.634,2.83,1.634-2.54,1.924Z",
    transform: "translate(-250.111 -162.05)",
    fill: "#1c1c1c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M305.588,179.389l2.83-1.634,2.83-1.634v6.536l-2.83-1.634Z",
    transform: "translate(-251.07 -172.853)",
    fill: "#1c1c1c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M281.217,170.224h5.661V162.05l-2.83,1.634-2.83,1.634",
    transform: "translate(-232.36 -162.05)",
    fill: "#1c1c1c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M281.217,211.283h5.661v8.174l-2.83-1.634-2.83-1.634",
    transform: "translate(-232.36 -199.848)",
    fill: "#1c1c1c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M305.588,207.531l2.83,1.634,2.83,1.634v-6.536l-2.83,1.634Z",
    transform: "translate(-251.07 -194.458)",
    fill: "#1c1c1c",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivitBlack);
export default __webpack_public_path__ + "static/media/divit-black.206df06341ad7cbb8cc7006735930db4.svg";
export { ForwardRef as ReactComponent };